import React, { lazy, Suspense } from 'react';
import LoadingIndicator from '@wix/da-ds/pkg/LoadingIndicator';
import retry from '@wix/da-shared-react/pkg/utils/webpack/chunkRetry';
import type { Props } from './ScheduleTimeForm';

const LoadableScheduleTimeForm = lazy(() =>
  retry(
    () =>
      import(
        /* webpackChunkName: "scheduletimeform" */
        './ScheduleTimeForm'
      )
  )
);

const LazyScheduleTimeForm: React.FC<Props> = props => (
  <Suspense fallback={<LoadingIndicator view={'spinner'} />}>
    <LoadableScheduleTimeForm {...props} />
  </Suspense>
);
LazyScheduleTimeForm.displayName = 'LazyScheduleTimeForm';

export default LazyScheduleTimeForm;
